<template>
  <component :is="routeLayout" :key="`${storeCode}-${departmentCode}`">
    <router-view />
  </component>
</template>

<script>
const { version } = require("../package.json");

export default {
  name: "App",
  data() {
    return {
      layout: this.$system_config.layoutDefault
    };
  },
  metaInfo: {
    meta: [
      { vmid: "release-version", name: "release-version", content: version }
    ]
  },
  mounted() {
    console.log(
      "App mounted",
      this.$route.params?.storeCode,
      this.$route.params?.departmentCode
    );
    // Set initial lang attribute
    this.updateHtmlLang();
  },
  watch: {
    "$i18n.locale"() {
      // Update lang attribute whenever language changes
      this.updateHtmlLang();
    }
  },
  methods: {
    updateHtmlLang() {
      document.documentElement.lang = this.$i18n.locale;
    }
  },
  computed: {
    routeLayout() {
      return (
        this.$route.meta?.layout ||
        this.$route.matched.find(m => m.meta.layout)?.meta?.layout ||
        this.layout
      );
    },
    storeCode() {
      return this.$route.params.storeCode;
    },
    departmentCode() {
      return this.$route.params.departmentCode || "all";
    }
  }
};
</script>
<style lang="scss">
@import "@/assets/style/css/App.scss";
</style>
